import React, { useState, useEffect, useCallback, } from 'react';
import { QUESTION_VALUE_TYPE } from '../../../../constants/common';
import AnswerItem from './answer.item';
import { useDispatch } from 'react-redux';
import { setAutoSavedPending } from '../../../../actions/survey.sample.action';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

const AnswerList = ({
  sample,
  answers,
  onAnswerChange,
  onHiddeChange,
  onAnswerIdOrderChange,
  hiddenAnswers,
  answerIdOrders
}) => {
  const [answerList, setAnswerList] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!answers) return;
    const answerMaps = {};
    answers.forEach((answer) => {
      answerMaps[answer.id] = answer.value;
    });
    setAnswerList(answerMaps);
  }, [answers]);

  const handleToggleHidden = (answer) => {
    let hiddenList = [...hiddenAnswers];
    const hiddenItemIndex = hiddenList.indexOf(answer.id);
    if (hiddenItemIndex >= 0) {
      hiddenList.splice(hiddenItemIndex, 1);
    } else {
      hiddenList.push(answer.id);
    }
    onHiddeChange(hiddenList);
    onAnswerIdOrderChange(answerIdOrders);
    dispatch(setAutoSavedPending())
  }

  const moveCard = useCallback((result) => {
    if (!result.destination) {
      return;
    }
    const list = [...answerIdOrders];
    const [removedItem] = list.splice(result.source.index, 1);
    list.splice(result.destination.index, 0, removedItem);
    onAnswerIdOrderChange(list);
    onHiddeChange(hiddenAnswers);
  }, [answerIdOrders, onHiddeChange, hiddenAnswers, onAnswerIdOrderChange]);

  return <>
    {sample?.Data.valueType !== QUESTION_VALUE_TYPE.MULTIPLE && answers.length > 0 && (
      <div>
        <h4>Answers</h4>
        <DragDropContext onDragEnd={moveCard}>
          <Droppable droppableId="droppable">
            {(provided) => (
              <div ref={provided.innerRef} {...provided.droppableProps}>
                {answerIdOrders.map((id, index) => {
                  const hiddenAnswer = hiddenAnswers.indexOf(id) >= 0;
                  return <Draggable
                    key={index}
                    draggableId={`draggable-report-item-${index}`}
                    index={index}
                  >
                    {(draggableProvided) => (
                      <AnswerItem
                        draggableProvided={draggableProvided}
                        moveCard={moveCard}
                        key={index}
                        answer={{ id, value: answerList[id] }}
                        index={index}
                        hiddenAnswer={hiddenAnswer}
                        onAnswerChange={onAnswerChange}
                        handleToggleHidden={handleToggleHidden}
                      />
                    )}
                  </Draggable>
                })}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </div >
    )}</>
};

export default AnswerList;
